<script setup lang="ts">
const route = useRoute()
const localePath = useLocalePath()

const display = ref(false)

onMounted(async () => {
  if (route.query.confirm) {
    display.value = true
    await navigateTo(localePath({ replace: true, query: {} }))
    window.setTimeout(() => {
      display.value = false
    }, 3300)
  }
})
</script>

<template>
  <Transition name="fade" mode="out-in">
    <div v-if="display" class="influencerProfileEditConfirmWrapper">
      <i class="fa-solid fa-circle-info tw-mr-2 tw-block tw-text-xl" />
      <div class="tw-text-[18px] tw-font-bold">
        {{ $t('influencer.profile.slug.edit.confirm00') }}
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.influencerProfileEditConfirmWrapper {
  @apply tw-absolute tw-left-0 tw-top-0 tw-z-[4] tw-flex tw-w-full tw-items-center tw-justify-center tw-bg-gradient-to-r tw-from-yellow-500 tw-to-pink-500 tw-px-8 tw-py-4 tw-text-white;
}
</style>
